import Immutable from 'seamless-immutable';
import _ from 'lodash';
import IntegrationTemplateModel from './integration-template-model';

function create(template = []) {
  return Immutable(_.map(template, IntegrationTemplateModel.create));
}

function deserialize(template = []) {
  return Immutable(_.map(template, IntegrationTemplateModel.deserialize));
}

export default {
  create,
  deserialize,
};
